"use client";

export const AboutStory = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Left column - Main story */}
          <div className="md:col-span-2 animate-in slide-in-from-left duration-700">
            <div className="bg-white p-6 sm:p-8 mb-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <div className="border-b-2 border-gray-900 pb-4 mb-6">
                <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 leading-tight">From Humble Beginnings to Industry Leadership: <br className="hidden sm:block" />Our Story</h2>
                <div className="flex items-center gap-2 text-sm text-amber-700 uppercase tracking-wide font-semibold mt-2">
                  <span className="w-8 h-0.5 bg-amber-500"></span>
                  Company History
                </div>
              </div>

              <div className="columns-1 md:columns-2 gap-6 text-gray-700 leading-relaxed text-justify">
                <p className="mb-4">
                  <span className="font-bold text-2xl float-left mr-0.5 leading-none text-amber-600">F</span>
                  ounded in 1999 by a team of U.S.-educated travel enthusiasts,
                  Travel Warehouse Inc. (TWI) began with just six members and a
                  bold vision: to deliver reliable, personalized, and
                  service-driven travel experiences in the Philippines. From
                  managing Jollibee's employee conversions in our first year to
                  serving top multinational clients like Philips and Ayala Land,
                  our journey has been defined by excellence and growth. 
                </p>
                <p className="mb-4">
                  Today, TWI is a trusted name in the industry, powered by over 30
                  professionals and a commitment to 24/7 client support. With
                  global partnerships and a local heart, we go beyond bookings
                  to build lasting relationships. And through our CSR
                  efforts—supporting schools and disaster relief—we continue to
                  give back to the community that inspires us.
                </p>
              </div>
            </div>
          </div>

          {/* Right sidebar - Secondary stories */}
          <div className="md:col-span-1 space-y-6 animate-in slide-in-from-right duration-700" style={{ animationDelay: '200ms' }}>
            <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <h3 className="text-xl font-bold text-gray-900 border-b-2 border-gray-900 pb-3 mb-4">
                Quick Facts
              </h3>
              <ul className="space-y-3 text-sm text-gray-700">
                <li className="border-l-4 border-orange-500 pl-3 py-1 hover:bg-orange-50 transition-colors">
                  <span className="font-bold">Founded:</span> 1999
                </li>
                <li className="border-l-4 border-orange-500 pl-3 py-1 hover:bg-orange-50 transition-colors">
                  <span className="font-bold">Headquarters:</span> Ortigas
                  Center, Pasig City
                </li>
                <li className="border-l-4 border-orange-500 pl-3 py-1 hover:bg-orange-50 transition-colors">
                  <span className="font-bold">Specialization:</span>{" "}
                  International & Domestic Travel
                </li>
                <li className="border-l-4 border-orange-500 pl-3 py-1 hover:bg-orange-50 transition-colors">
                  <span className="font-bold">Services:</span> Tours, Visa
                  Assistance, Hotel Bookings
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-amber-100/50 p-6 rounded-lg shadow-lg border-2 border-amber-200 hover:shadow-xl transition-shadow">
              <h3 className="text-lg font-bold text-gray-900 border-b-2 border-amber-600 pb-3 mb-4">
                Customer Testimonial
              </h3>
              <blockquote className="text-sm text-gray-700 italic leading-relaxed mb-3">
                "Travel Warehouse made our dream European vacation a reality.
                Every detail was perfect!"
              </blockquote>
              <div className="text-xs text-gray-600 font-semibold">
                — Satisfied Customer, Manila
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};